import React from 'react';


import Footer from '../footer';

import { UserProvider, useUser } from '../../context/UserContext'

export default function Causas() {
  return (
    <UserProvider>
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <h1>Error 404</h1>
      </div>
      <Footer />
    </UserProvider>
  )
}